import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RowBody } from "../../../components/RowValue/RowBody";
import { selectTraggliedTitle } from "../../../store/slices/traggliedSlice";
import DesignLoadSelection from "./DesignLoadSelection";

function SelectedLoadCarryingElement({ readOnly = false }) {
  const { t } = useTranslation("translation");

  const traggliedTitle = useSelector(selectTraggliedTitle);

  function renderInput() {
    return readOnly ? <span className="input">{traggliedTitle}</span> : <DesignLoadSelection />;
  }

  let localTitle = readOnly
    ? t("inner.verificationCapacity.selectedLoadCarryingElement")
    : t("inner.verificationCapacity.loadCarryingElement");
  return <RowBody titleValue={<p>{localTitle}</p>} inputValue={renderInput()} />;
}

export default SelectedLoadCarryingElement;
